<app-status #status></app-status>

<div *ngIf="!status?.visible">
  <!-- ≥ 768px -->
  <table class="table-ladder table-sm d-none d-md-table" *ngIf="resources.length > 0">
    <thead>
      <tr>
        <th *ngFor="let column of visibleColumns()" [ngStyle]="column.style"
          ngClass="{{column.cls}} {{column.type}} {{ column.format }}"
          (click)="onColumnClick($event, column)"
        >
          <i [class]="column.icon" *ngIf="column.type != 'select' && column.icon"></i>
          {{ column.type == 'select' ? '' : column.title }}
          <i class="far fa-check-square" *ngIf="column.type == 'select'"></i>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of resources" (click)="onDblClickItem($event, item)">
        <td *ngFor="let column of visibleColumns()"
          (click)="column.type == 'select' ? selectItem($event, item, column) : column.clickEvent ? column.clickEvent($event, item) : ''"
          [ngStyle]="column.style" [title]="column.title"
          ngClass="{{getCls(item, column)}} {{column.type}} {{ column.format }}
            {{ item[column.field + 'Cls'] }} {{!!column.clickEvent ? 'link' : ''}}
          "
        >
          <span *ngIf="!column.type">
            {{ column.valueCallback ? column.valueCallback(item) : getItemValue(item, column) }}
            <small>{{ column.complement ? column.complement(item) : '' }}</small>
          </span>

          <!-- Select -->
          <i *ngIf="column.type == 'select'"
            [ngClass]="item[column.field] ? 'fas fa-check-square' : 'far fa-square'" >
          </i>

          <!-- Status -->
          <i class="fa fa-circle" [ngClass]="item[column.field] ? 'text-success' : 'text-danger'"
            *ngIf="column.type == 'boolean'">
          </i>

          <!-- Options -->
          <!-- [ngClass]="options.length > 1 ? 'hide' : 'show'" -->
          <span class="icons-box hide" *ngIf="column.type == 'options'">
            <i class="fas fa-angle-right close-options"></i>
            <span class="option" *ngFor="let opt of options; let idx = index">
              <i [ngClass]="opt.icon" *ngIf="!opt.condition || (!!opt.condition && opt.condition(item))"
                (click)="opt.clickEvent($event, item)" [title]="opt.title">
              </i>
            </span>
            <i class="fas fa-angle-left open-options"></i>
          </span>
        </td>
      </tr>
    </tbody>
    <tfoot *ngIf="showTotal">
      <tr>
        <td *ngFor="let tot of total" [ngStyle]="tot.style" ngClass="{{tot.cls}} {{tot.format}} {{tot.style}}" title="Σ {{tot.title}}">
          <span>{{tot.value}}</span>
        </td>
      </tr>

      <tr *ngIf="totalSelected.length > 0">
        <td *ngFor="let tot of totalSelected" ngClass="{{tot.cls}} {{tot.format}} {{tot.type}}" [ngStyle]="tot.style" title="Σ {{tot.title}}">
          <i class="fas fa-check-square" *ngIf="tot.type === 'select'"></i>

          <span *ngIf="tot.type !== 'select'">{{tot.value}}</span>
        </td>
      </tr>
    </tfoot>
  </table>

  <!-- < 768px -->
  <table class="table-ladder table-mobile d-table d-md-none" *ngIf="resources.length > 0">
    <tbody>
      <div class="mobile-box" *ngFor="let item of resources" (click)="onDblClickItem($event, item)">
        <tr class="mobile-header">
          <td class="select" *ngIf="!!selectField">
            <i (click)="selectItem($event, item, null)" [ngClass]="item[selectField] ? 'fas fa-check-square' : 'far fa-square'"></i>
          </td>
          <td class="icons-box" *ngIf="options.length > 0">
            <div class="option-box" *ngFor="let opt of options; let idx = index" [hidden]="!!opt.condition && !opt.condition(item)"
              (click)="opt.clickEvent($event, item)"
            >
              <i class="option" [ngClass]="opt.icon" [title]="opt.title"></i>
              <span class="option-title">{{opt.title}}</span>
            </div>
          </td>
          <td class="boolean" *ngIf="!!booleanField">
            <i class="fa fa-circle" [ngClass]="item[booleanField] ? 'text-success' : 'text-danger'"></i>
          </td>
        </tr>
        <tr *ngFor="let column of columns; let idx = index" (click)="column.clickEvent ? column.clickEvent($event, item) : ''">
          <ng-container *ngIf="['options', 'select', 'boolean'].indexOf(column.type) === -1">
            <td class="col-label">
              {{columns[idx].title}}
            </td>
            <td class="col-value" ngClass="{{ item[column.field + 'Cls'] }}" [ngStyle]="column.style">
              <span *ngIf="!column.type">
                {{ column.valueCallback ? column.valueCallback(item) : getItemValue(item, column) }}
                <small>{{ column.complement ? column.complement(item) : '' }}</small>
              </span>
            </td>
          </ng-container>
        </tr>
      </div>
    </tbody>
  </table>

  <div class="alert alert-info" style="margin: .5rem;" role="alert" *ngIf="resources.length === 0">
    <strong *ngIf="emptyMessage">{{ emptyMessage }}</strong>
    <span *ngIf="!emptyMessage"><strong>Nenhum registro.</strong> Encontre os registros desejados com os filtros acima.</span>
  </div>
</div>
